module.exports = __webpack_public_path__ + "static/media/python_logo.067050f6.png";